(() => {
  'use strict';
  if (window.IDGCampaignHero) { window.IDGCampaignHero.init(document); return; }
  const instances = new Map();
  const positions = [3, 53, 93, 41, 84, 16, 96, 57, 46, 7, 88, 35, 61, 98, 25, 78];
  function mount(root) {
    if (instances.has(root) || root.dataset.ribbons !== 'true') return;
    const layer = root.querySelector('[data-ribbon-layer]');
    const stage = root.querySelector('.idg-ch-stage');
    const button = root.querySelector('[data-ribbon-toggle]');
    if (!layer || !stage || !button) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let manuallyPaused = false;
    const count = { low: 6, medium: 10, high: 16 }[root.dataset.density] || 10;
    const seconds = parseFloat(getComputedStyle(root).getPropertyValue('--idg-ch-duration')) || 20;
    for (let i = 0; i < count; i += 1) {
      const piece = document.createElement('span');
      const near = i % 4 === 0;
      piece.className = `idg-ch-ribbon${i % 3 === 1 ? ' idg-ch-ribbon--curl' : ''}${near ? ' idg-ch-ribbon--near' : ''}`;
      const duration = seconds + (i % 5) * 1.4;
      const styles = {
        '--r-x': `${positions[i]}%`, '--r-width': `${near ? 23 : 10 + i % 3 * 3}px`,
        '--r-height': `${near ? 59 : 25 + i % 4 * 7}px`, '--r-angle': `${i * 31}deg`,
        '--r-drift': `${i % 2 ? -38 : 30}px`, '--r-opacity': near ? '.72' : '.56',
        '--r-duration': `${duration}s`, '--r-delay': `${-duration * ((i * .137 + .12) % 1)}s`
      };
      Object.entries(styles).forEach(([key, value]) => piece.style.setProperty(key, value));
      piece.appendChild(document.createElement('i'));
      layer.appendChild(piece);
    }
    function size() {
      const distance = stage.offsetHeight + 130;
      layer.style.setProperty('--r-distance', `${distance}px`);
      layer.style.setProperty('--r-middle', `${distance * .45}px`);
    }
    function update() {
      const playing = inView && !document.hidden && !reduce.matches && !manuallyPaused;
      root.dataset.ribbonPlaying = String(playing);
      button.hidden = reduce.matches;
      button.setAttribute('aria-pressed', String(manuallyPaused));
      const label = manuallyPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
      button.querySelector('[data-ribbon-label]').textContent = label;
      button.querySelector('[data-ribbon-icon]').textContent = manuallyPaused ? '▷' : 'Ⅱ';
    }
    function toggle() { manuallyPaused = !manuallyPaused; update(); }
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting; update();
    }, { threshold: 0 }) : null;
    if (observer) observer.observe(stage);
    else inView = true;
    const resize = 'ResizeObserver' in window ? new ResizeObserver(size) : null;
    if (resize) resize.observe(stage);
    else window.addEventListener('resize', size);
    reduce.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    button.addEventListener('click', toggle);
    size();
    root.dataset.ribbonReady = 'true';
    update();
    instances.set(root, () => {
      observer?.disconnect(); resize?.disconnect();
      window.removeEventListener('resize', size);
      reduce.removeEventListener('change', update);
      document.removeEventListener('visibilitychange', update);
      button.removeEventListener('click', toggle);
      layer.replaceChildren();
      delete root.dataset.ribbonReady; delete root.dataset.ribbonPlaying;
      button.hidden = true;
      instances.delete(root);
    });
  }
  function init(context) {
    if (context.matches?.('[data-campaign-hero]')) mount(context);
    context.querySelectorAll('[data-campaign-hero]').forEach(mount);
  }
  function unload(context) {
    [...instances.keys()].filter(root => context === root || context.contains(root)).forEach(root => instances.get(root)());
  }
  window.IDGCampaignHero = { init, unload };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
})();
